import React from 'react';
// import flexible from '../../utils/flexible';
import './index.less';
import hic_mobile_pic2 from './img/20211015.png';

class Banner20211015 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    // document.title = '充电安全须知';
    return (
        <div id="banner">
            <img src={hic_mobile_pic2} />
        </div>
    );
  }
}

export default Banner20211015;



// WEBPACK FOOTER //
// ./src/staticPage/banner/20211015/index.js